import { Space } from '@procurify/ui'

import { type ConversationChoiceOption } from '../../value-objects/ConversationTurnItem'
import { ConversationChip } from '../ConversationChip'

export interface IConfirmationOptionsProps {
  options: ConversationChoiceOption[]
  disabled?: boolean
  onSelect: (option: ConversationChoiceOption) => void
}

export const ConfirmationOptions = ({
  options,
  disabled = false,
  onSelect,
}: IConfirmationOptionsProps) => {
  if (options.length === 0) {
    return null
  }

  return (
    <Space direction='horizontal' size='small' flexWrap>
      {options.map((option) => (
        <ConversationChip
          key={option.value}
          analyticsId='conversation-confirmation-option-chip'
          disabled={disabled}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </ConversationChip>
      ))}
    </Space>
  )
}
